// Module
var code = `<div class="js-instrument-total-info" style="{{>visibility}}">
    {{#if isHedging}}
        <div class="total-info-container">
            <div class="total-info-column {{items[3].BackColorClass}}">
                <div class="js-value">{{items[3].Label}}</div>
                <div class="js-title">{{breakEvenText}}</div>
            </div>
        </div>
        <div class="total-info-long-short-container">
            <div class="total-info-column {{items[5].BackColorClass}}">
                <div class="js-value">{{items[5].Label}}</div>
                <div class="js-title">{{quantityText}}</div>
            </div>
            <div class="total-info-column {{items[6].BackColorClass}}">
                <div class="js-value">{{items[6].Label}}</div>
                <div class="js-title">{{quantityText}}</div>
            </div>
        </div>
    {{else}}
        <div class="total-info-container">
            <div class="total-info-column {{items[2].BackColorClass}}">
                <div class="js-value">{{items[2].Label}}</div>
                <div class="js-title">{{avgPriceText}}</div>
            </div>
        </div>
        <div class="total-info-container">
            <div class="total-info-column {{items[4].BackColorClass}}">
                <div class="js-value">{{items[4].Label}}</div>
                <div class="js-title">{{quantityText}}</div>
            </div>
        </div>
    {{/if}}
    <div class="total-info-container">
        <div class="total-info-column {{items[1].BackColorClass}}">
            <div class="js-value">{{items[1].Label}}</div>
            <div class="js-title">{{plText}}</div>
        </div>
    </div>
</div>`;
// Exports
export default code;